import { extendNewObject } from '@/lib/utils.js'

// 確認メッセージの基本設定
const SwalDefaultSetting = {
  title: '登録確認',
  text: 'この内容で登録しますか？',
  icon: 'question',
  showCancelButton: true,
  confirmButtonColor: '#DD6B55',
  confirmButtonText: '登録する',
  cancelButtonText: 'キャンセル',
  reverseButtons: true
}

export default {
  ja: {
    SYSTEM: {
      SITENAME: '山の天気予報 管理画面'
    },
    TOAST: {
      default: {
        success: '通知',
        info: '通知',
        danger: '警告'
      }
    },
    LABEL: {
      pageFormat: '{page}/{maxpage} (全{total}件)',
      loginId: 'ログインID',
      email: 'メールアドレス',
      passwd: 'パスワード'
    },
    BUTTON: {
      login: 'ログイン',
      logout: 'ログアウト',
      cancel: 'キャンセル'
    },
    PLACEFOLDER: {
      loginId: 'ログインIDを入力してください',
      email: 'メールアドレスを入力してください',
      passwd: 'パスワードを入力してください'
    },
    // PAGES pageid は コンポーネント名
    PAGES: {
      Error: {
        title: 'システムエラーが発生しました',
        subheading: '下記のエラーが発生しました',
        icon: 'exclamation'
      },
      Login: {
        title: 'ログイン',
        subheading: 'ログインID及びパスワードを入力してください',
        icon: 'sign-in-alt'
      },
      OTP: {
        title: '認証',
        subheading: '6桁の確認コードを入力してください',
        icon: 'key'
      },
      Logout: {
        title: 'ログアウト',
        subheading: '',
        icon: 'sign-out-alt',
        swalConf: 'ログアウトしますか？'
      },
      Dashboard: {
        title: 'ダッシュボード',
        subheading: '',
        icon: 'tachometer-alt',
        url: '/'
      },
      Members: {
        title: '会員管理',
        subheading: '会員情報の追加・変更・削除を行います。',
        icon: 'users',
        url: '/members/',
        memberadd: '会員新規登録'
      },
      MemberInsert: {
        title: '会員新規追加',
        subheading: '会員の新規追加を行います。',
        icon: 'user-plus'
      },
      MemberDelete: {
        title: '会員削除',
        subheading: '会員の新規追加を行います。',
        icon: 'user-edit'
      },
      MemberEdit: {
        title: '会員変更・削除',
        subheading: '会員の変更または削除を行います。',
        icon: 'user-edit',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '登録確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '登録する'
          }),
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          }),
          delete: extendNewObject(SwalDefaultSetting, {
            title: '削除確認',
            text: 'この内容を削除しますか？',
            icon: 'question',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: '削除する'
          })
        }
      },
      MountainArea: {
        title: '山域設定',
        subheading: '山域の追加・変更・削除を行います。',
        icon: 'chart-area',
        url: '/mountainarea',
        add: '山域の追加',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '登録確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '登録する'
          }),
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          }),
          delete: extendNewObject(SwalDefaultSetting, {
            title: '削除確認',
            text: 'この内容を削除しますか？',
            icon: 'question',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: '削除する'
          })
        }
      },
      MountainAreaInsert: {
        title: '山域の追加',
        subheading: '山域の追加を行います。',
        icon: 'chart-area'
      },
      MountainAreaEdit: {
        title: '山域の変更・削除',
        subheading: '山域の変更・削除を行います。',
        icon: 'chart-area'
      },

      Mountains: {
        title: '山設定',
        subheading: '山の追加・変更・削除を行います。',
        icon: 'mountain',
        url: '/mountains',
        add: '山の追加',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '登録確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '登録する'
          }),
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          }),
          delete: extendNewObject(SwalDefaultSetting, {
            title: '削除確認',
            text: 'この内容を削除しますか？',
            icon: 'question',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: '削除する'
          })
        }
      },
      MountainsInsert: {
        title: '山の追加',
        subheading: '山の追加を行います。',
        icon: 'mountain'
      },
      MountainsEdit: {
        title: '山の変更・削除',
        subheading: '山の変更・削除を行います。',
        icon: 'mountain'
      },
      MountainCameraEdit: {
        title: 'ライブカメラの設定',
        subheading: '指定した山へライブカメラの追加・変更・削除を行います。',
        icon: 'camera'
      },
      Payupdate: {
        title: '定期課金CSV反映',
        subheading: 'イプシロンからダウンロードしたCSVを投入し定期課金データの更新を行います。',
        icon: 'file-upload',
        SWAL: {
          update: extendNewObject(SwalDefaultSetting, {
            title: '更新処理実行確認',
            text: 'このファイルで更新処理を実行しますか？',
            confirmButtonText: '実行する'
          })
        }
      },
      News: {
        title: '一般のお知らせ',
        subheading: '一般のお知らせの追加・変更・削除を行います。',
        icon: 'envelope',
        url: '/news',
        add: 'お知らせの追加',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '登録確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '登録する'
          }),
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          }),
          delete: extendNewObject(SwalDefaultSetting, {
            title: '削除確認',
            text: 'この内容を削除しますか？',
            icon: 'question',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: '削除する'
          })
        }
      },
      NewsInsert: {
        title: '一般のお知らせの追加',
        subheading: 'お知らせの追加を行います。登録後、お知らせメールが自動で配信されます。',
        icon: 'envelope'
      },
      NewsEdit: {
        title: '一般のお知らせの変更・削除',
        subheading: 'お知らせの変更・削除を行います。',
        icon: 'envelope'
      },
      News1: {
        title: '重要なお知らせ',
        subheading: '重要なお知らせの追加・変更・削除を行います。',
        icon: 'exclamation-triangle',
        url: '/news'
      },
      News1Insert: {
        title: '重要なお知らせの追加',
        subheading: '重要なお知らせの追加を行います。登録後、お知らせメールが自動で配信されます。',
        icon: 'envelope'
      },
      News1Edit: {
        title: '重要なお知らせの変更・削除',
        subheading: '重要なお知らせの変更・削除を行います。',
        icon: 'envelope'
      },
      News2: {
        title: '天気のお知らせ',
        subheading: '天気のお知らせの追加・変更・削除を行います。',
        icon: 'bell',
        url: '/news'
      },
      News2Insert: {
        title: '天気のお知らせの追加',
        subheading: '天気のお知らせの追加を行います。',
        icon: 'bell'
      },
      News2Edit: {
        title: '天気のお知らせの変更・削除',
        subheading: '天気のお知らせの変更・削除を行います。',
        icon: 'bell'
      },
      Livecamera: {
        title: 'ライブカメラ設定',
        subheading: 'ライブカメラの追加・変更・削除を行います。',
        icon: 'camera',
        url: '/livecamera',
        add: 'ライブカメラの追加',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '登録確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '登録する'
          }),
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          }),
          delete: extendNewObject(SwalDefaultSetting, {
            title: '削除確認',
            text: 'この内容を削除しますか？',
            icon: 'question',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: '削除する'
          })
        }
      },
      LivecameraInsert: {
        title: 'ライブカメラの追加',
        subheading: 'ライブカメラの追加を行います。',
        icon: 'camera'
      },
      LivecameraEdit: {
        title: 'ライブカメラの変更・削除',
        subheading: 'ライブカメラの変更・削除を行います。',
        icon: 'camera'
      },
      Typhoon: {
        title: '台風情報',
        subheading: '台風情報の追加・変更・削除を行います。新規登録時には自動でお知らせメールが配信されます。',
        icon: 'wind',
        url: '/typhoon',
        add: '新しい台風情報の追加',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '登録確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '登録する'
          }),
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          }),
          delete: extendNewObject(SwalDefaultSetting, {
            title: '削除確認',
            text: 'この内容を削除しますか？',
            icon: 'question',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: '削除する'
          })
        }
      },
      TyphoonInsert: {
        title: '台風情報追加',
        subheading: '台風情報の新規追加を行います。登録後、お知らせメールが自動で配信されます。',
        icon: 'wind'
      },
      TyphoonEdit: {
        title: '台風情報変更・削除',
        subheading: '台風情報の変更・削除を行います。',
        icon: 'wind'
      },
      Characteristic: {
        title: '気象特性設定',
        subheading: 'コラムに気象特性の追加・変更・削除を行います。',
        icon: 'cloud-sun',
        url: '/characteristic',
        add: '気象特性の追加',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '登録確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '登録する'
          }),
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          }),
          delete: extendNewObject(SwalDefaultSetting, {
            title: '削除確認',
            text: 'この内容を削除しますか？',
            icon: 'question',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: '削除する'
          })
        }
      },
      CharacteristicInsert: {
        title: '気象特性新規追加',
        subheading: '気象特性の新規追加を行います。',
        icon: 'cloud-sun'
      },
      CharacteristicEdit: {
        title: '気象特性変更・削除',
        subheading: '気象特性の変更・削除を行います。',
        icon: 'cloud-sun'
      },
      KakinLog: {
        title: '決済ログ',
        subheading: '決済情報を確認できます。',
        icon: 'comment-dollar'
      },
      KakinPointEdit: {
        title: 'ポイント変更',
        subheading: 'ポイント変更できます。',
        icon: 'calendar-alt',
        SWAL: {
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          })
        }
      },
      KmailLog: {
        title: '決済メール',
        subheading: '決済メールを確認できます。',
        icon: 'envelope'
      },
      PaymentLog: {
        title: '決済情報ログ(旧)',
        subheading: '決済情報を確認できます。',
        icon: 'comment-dollar'
      },
      Maillog: {
        title: 'メール配信状況',
        subheading: '現在のメール配信状況を確認できます。',
        icon: 'envelope'
      },
      Noticemail: {
        title: 'お知らせ送信',
        subheading: '会員及び退会者にお知らせメールを配信します。',
        icon: 'envelope',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: 'お知らせ配信確認',
            text: 'この内容でメールを配信しますか？',
            confirmButtonText: '配信する'
          })
        }
      },
      Fcstmail: {
        title: '通常予報配信',
        subheading: '通常予報のメールを配信します。',
        icon: 'envelope',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '通常予報配信確認',
            text: 'この内容でメールを配信しますか？',
            confirmButtonText: '配信する'
          })
        }
      },
      Stormmail: {
        title: '大荒れ情報配信',
        subheading: '大荒れ情報及び落雷臨時情報のメールを配信します。',
        icon: 'envelope',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '大荒れ情報配信確認',
            text: 'この内容でメールを配信しますか？',
            confirmButtonText: '配信する'
          })
        }
      },
      Recommendmail: {
        title: 'おすすめ山域配信',
        subheading: '今週のおすすめ山域情報のメールを配信します。',
        icon: 'envelope',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: 'おすすめ山域配信確認',
            text: 'この内容でメールを配信しますか？',
            confirmButtonText: '配信する'
          })
        }
      },
      Weekmail: {
        title: '週間天気予報配信',
        subheading: '週間天気予報（長期連休向け）情報のメールを配信します。',
        icon: 'envelope',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '週間天気予報配信確認',
            text: 'この内容でメールを配信しますか？',
            confirmButtonText: '配信する'
          })
        }
      },
      Typhoonmail: {
        title: '台風情報配信',
        subheading: '台風情報のメールを配信します。',
        icon: 'envelope',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '台風情報配信確認',
            text: 'この内容でメールを配信しますか？',
            confirmButtonText: '配信する'
          })
        }
      },
      Users: {
        title: '管理ユーザー設定',
        subheading: '管理ユーザーの追加・変更・削除を行います。',
        icon: 'users-cog',
        url: '/users/',
        useradd: 'ユーザー追加'
      },
      UserInsert: {
        title: '管理ユーザー新規追加',
        subheading: '管理ユーザーの新規追加を行います。',
        icon: 'user-plus'
      },
      UserDelete: {
        title: '管理ユーザー削除',
        subheading: '管理ユーザーの新規追加を行います。',
        icon: 'user-edit'
      },
      UserEdit: {
        title: '管理ユーザー変更・削除',
        subheading: '管理ユーザーの変更または削除を行います。',
        icon: 'user-edit',
        SWAL: {
          insert: extendNewObject(SwalDefaultSetting, {
            title: '登録確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '登録する'
          }),
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          }),
          delete: extendNewObject(SwalDefaultSetting, {
            title: '削除確認',
            text: 'この内容を削除しますか？',
            icon: 'question',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: '削除する'
          })
        }
      },
      Me: {
        title: 'マイアカウント変更',
        subheading: 'マイアカウントの変更を行います。',
        icon: 'user-lock',
        SWAL: {
          update: extendNewObject(SwalDefaultSetting, {
            title: '変更確認',
            text: 'この内容で登録しますか？',
            confirmButtonText: '変更する'
          })
        }
      }
    },
    DIC: {
      memberStatus: [
        { value: '0', text: '仮登録' },
        { value: '1', text: '本登録' },
        { value: '9', text: '退会' }
      ],
      premium: [
        { value: '0', text: '無料会員', shortText: '無料' },
        { value: '1', text: 'プレミアム会員', shortText: '有料' }
      ],
      premiumMountain: [
        { value: false, text: '', shortText: '無料' },
        { value: true, text: 'プレミアム', shortText: '有料' }
      ],
      enabled: [
        { value: false, text: '無効' },
        { value: true, text: '有効' }
      ],
      activecamera: [
        { value: false, text: '停止中' },
        { value: true, text: '動作中' }
      ],
      superForecast: [
        { value: false, text: '' },
        { value: true, text: 'S予報' }
      ],
      memberRank: [
        { value: 0, text: '無料会員' },
        { value: 1, text: 'ブロンズ' },
        { value: 2, text: 'シルバー' },
        { value: 3, text: 'ゴールド' },
        { value: 4, text: 'プラチナ' }
      ],
      memberBadge: [
        { value: '001', text: '初期会員' },
        { value: '110', text: '10年会員' },
        { value: '501', text: 'ご紹介' }
      ],
      systemNotice: [
        { value: false, text: '送信しない' },
        { value: true, text: '送信する', shortText: 'お知らせ' }
      ],
      weatherNotice: [
        { value: false, text: '送信しない' },
        { value: true, text: '送信する', shortText: '天気予報' }
      ],
      sendStormMail: [
        { value: false, text: '送信しない' },
        { value: true, text: '送信する' }
      ],
      climbing: [
        { value: false, text: '' },
        { value: true, text: '登山中' }
      ],
      noticeCategory: [
        { value: null, text: '全て' },
        { value: 1, text: '重要なお知らせ' },
        { value: 2, text: '天気のお知らせ' },
        { value: 3, text: '一般のお知らせ' }
      ],
      mailStatus: [
        { value: 1, text: '登録' },
        { value: 2, text: '送信中' },
        { value: 8, text: '送信エラー' },
        { value: 9, text: '送信完了' }
      ],
      mailType: [
        { value: 1, text: 'お知らせ' },
        { value: 2, text: '重要なお知らせ' },
        { value: 3, text: '天気のお知らせ' },
        { value: 11, text: '通常予報' },
        { value: 12, text: '大荒れ情報' },
        { value: 13, text: '落雷臨時情報' },
        { value: 14, text: 'おすすめ山域' },
        { value: 15, text: '週間予報' },
        { value: 16, text: '台風情報' },
        { value: 101, text: '定期課金更新' }

      ],
      memberType: [
        { value: 1, text: '全ての会員' },
        { value: 2, text: '対象の山にピンを設定している会員' },
        { value: 3, text: '対象の山域にピンを設定している会員' },
        { value: 9, text: '全ての会員' }
      ],
      dispFlg: [
        { value: false, text: '非表示' },
        { value: true, text: '表示' }
      ],
      payKbn: [
        { value: 1, text: '新規登録' },
        { value: 2, text: 'カード変更' },
        { value: 3, text: 'プレミアム変更' },
        { value: 4, text: '決済' },
        { value: 8, text: 'フリープラン変更' },
        { value: 9, text: '退会' }
      ],
      payPlan: [
        { value: 1, text: '定期課金' }
      ],
      payMethod: [
        { value: 0, text: '未設定' },
        { value: 1, text: 'クレジットカード' }
      ],
      payStatus: [
        { value: 0, text: '処理中または中断' },
        { value: 1, text: '正常終了' },
        { value: 9, text: '異常終了' }
      ],
      userState: [
        { value: '0', text: '無効' },
        { value: '1', text: '有効' }
      ],
      roles: [
        { value: 'admin', text: '管理者' },
        { value: '2', text: '問合せ対応' },
        { value: '1', text: '一般' }
      ]
    },
    MESSAGE: {
      sessionAlertTitle: 'セッション警告',
      sessionAlert: '{0}分後に自動でログアウトします',
      required: '入力必須です',
      notidpass: 'ログインIDまたはパスワードが違います。',
      notResult: 'データが存在しません',
      passwdUpdate: '変更時のみ入力してください。',
      loginSuccess: 'ログインしました',
      logoutSuccess: 'ログアウトしました',
      insertSuccess: '追加しました',
      updateSuccess: '更新しました',
      deleteSuccess: '削除しました',
      sendSuccess: '配信を開始しました',
      execSuccess: '更新処理を開始しました'
    },
    VALIDATE: {
      empty: '入力必須です',
      maxlength: '',
      minLength: '{0}文字以上入力してください',
      Alpha: '半角英字で入力してください',
      Alphanum: '半角英数字で入力してください',
      num: '数字で入力してください',
      float: '少数で入力してください',
      float6: '少数6桁までで入力してください',
      unmatchedPassword: 'パスワードが一致しません',
      email: 'メールアドレスが正しくありません。',
      hankaku: '半角文字のみ入力可能です。',
      zenkaku: '全角文字のみ入力可能です。',
      noalpha: '英字は許可されていません。',
      nonumber: '数字は許可されていません。',
      nohanspace: '半角スペースは許可されていません。',
      nozenspace: '全角スペースは許可されていません。',
      nosign: '記号は許可されていません。',
      nodot: '.（ドット）は許可されていません。',
      nohyphen: '-（ハイフン）は許可されていません。',
      noslash: '/（スラッシュ）は許可されていません。',
      nocolon: ':（コロン）は許可されていません。',
      nozenkana: '全角カタカナは許可されていません。',
      nozenhira: '全角ひらがなは許可されていません。',
      nohankana: '半角カタカナは許可されていません。',
      existsEmail: '既に登録されています',
      uniqecode: '既に登録されています。'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/lang/lang_JP.js